import { useBooleanState } from '@cian/react-utils';
import { IconButton } from '@cian/ui-kit';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

import { type ReactNode, type SyntheticEvent, useCallback } from 'react';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors';

import { stopPropagation } from '@/packages/utils/event';

import { useToggleFavorite } from '../../../hooks/card/useToggleFavorite';

export function FavoritesActionButtonContainer(): ReactNode {
  const {
    data: {
      extendedProperties: { isFavorite },
    },
  } = useCardOfferContext();

  const { state: isHovered, setTrue: setIsHovered, setFalse: setIsBlured } = useBooleanState(false);

  const toggleFavorite = useToggleFavorite();

  const handleToggleFavorite = useCallback(
    (e: SyntheticEvent) => {
      stopPropagation(e);
      toggleFavorite();
    },
    [toggleFavorite],
  );

  return (
    <IconButton
      data-testid="card.favorites-control"
      icon={
        isFavorite ? (
          <IconToggleHeartOn16 color="icon-negative-default" />
        ) : (
          <IconToggleHeartOff16 color={isHovered ? 'icon-negative-hovered' : 'control-negative-primary-default'} />
        )
      }
      title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      onClick={handleToggleFavorite}
      onMouseEnter={setIsHovered}
      onMouseLeave={setIsBlured}
    />
  );
}
